import { useCallback } from 'react'
import { useApi } from '@/lib/api'

export interface WorkerEndDateConflict {
  userProfileId: number
  hasSubmittedHoursConflict: boolean
  hasTransactionConflict: boolean
  hasConflict: boolean
}

/**
 * Pre-flight check for shortening a worker's Last Day of Work. Asks the EngagementService whether the
 * worker has submitted timesheet hours or live financial transactions dated after a proposed date, so the
 * UI can block an invalid shorten before it is saved. The same guards run again during the legacy sync as a
 * backstop, but blocking here keeps the bad date out of the engagement doc (a failed sync would otherwise
 * leave the shortened date persisted while the work order was never wound down).
 */
export function useWorkerEndDateConflict() {
  const { engagementApi } = useApi()

  const checkEndDateConflict = useCallback(
    // recordId scopes the check to this engagement's assignment — matching the engagement-scoped guard;
    // without it the check would over-block on a worker's hours/transactions from other engagements.
    async (recordId: number, workerUserProfileId: number, proposedEndDate: string): Promise<WorkerEndDateConflict> => {
      const path = `/api/Engagement/${recordId}/worker/${workerUserProfileId}/end-date-conflicts?proposedEndDate=${proposedEndDate}`
      return await engagementApi.get<WorkerEndDateConflict>(path)
    },
    [engagementApi]
  )

  return { checkEndDateConflict }
}
